import { Box, TextFieldProps } from '@mui/material';
import { color, EL_COLORS } from '@/colors';
import { Flex } from '@/UI/styles';
import { EllipsisText } from '@/UI/EllipsisText/EllipsisText';
import { NodeTextField } from '@/UI/NodeTextField/NodeTextField';
import type { TextAsset } from '@/types/api/assets';

interface TextViewerProps {
  file: TextAsset;
  index: number;
  onTextChange?: (index: number, value: string) => void;
  hasMultipleFiles?: boolean;
  isMultiFilesViewMode: boolean;
  fixedItemSize?: number;
}

export function TextViewer({
  file,
  index,
  onTextChange,
  hasMultipleFiles,
  isMultiFilesViewMode,
  fixedItemSize,
}: TextViewerProps) {
  return (
    <Flex sx={{ bgcolor: color.Black84, width: '100%', position: 'relative' }} className="nodrag">
      {isMultiFilesViewMode ? (
        <Box
          sx={{
            bgcolor: color.Black84,
            width: '100%',
            height: `${fixedItemSize!}px`,
            px: 3,
            borderRadius: 2,
            border: `1px solid ${EL_COLORS.BoxBorder}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <EllipsisText
            variant="body-std-rg"
            isMultiLine
            linesNumber={fixedItemSize! > 200 ? 8 : 4}
            sx={{
              color: color.White64_T,
              width: '100%',
              fontSize: '16px',
              wordBreak: 'break-word',
            }}
          >
            {'value' in file ? file.value : ''}
          </EllipsisText>
        </Box>
      ) : (
        <NodeTextField
          color={color.White64_T as TextFieldProps['color']}
          expandable={true}
          enableMouseWheelScroll={false}
          maxHeight={fixedItemSize}
          value={'value' in file ? file.value : ''}
          multiline
          minRows={6}
          fullWidth
          size="small"
          onChange={(e) => {
            if (onTextChange) {
              onTextChange(index, e.target.value);
            }
          }}
          sx={{
            bgcolor: color.Black84,
            borderColor: EL_COLORS.BoxBorder,
            '& .MuiOutlinedInput-root': {
              transition: 'padding 0.1s ease-in-out',
              borderRadius: 2,
              p: 3,
              pt: hasMultipleFiles ? 5 : 3,
              pb: 4,
              '& fieldset': {
                borderColor: EL_COLORS.BoxBorder,
              },
              '&:hover fieldset': {
                borderColor: EL_COLORS.BoxBorder,
              },
              '&.Mui-focused fieldset': {
                borderColor: EL_COLORS.BoxBorder,
              },
            },
          }}
        />
      )}
    </Flex>
  );
}
